// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

export function deleteData(dataId, servicesConfig, successMessage) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                type: 'DELETE_DATA_FULFILLED',
                response: jsonResponse || successMessage,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'DELETE_DATA_REJECTED',
                error,
            });
        };
        const actionParams = {
            servicesConfig,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'DELETE_DATA',
        });

        return actionsServiceCaller(actionParams, {}, dataId);
    };
}

export function deleteDataReset() {
    return (dispatch) => {
        dispatch({
            type: 'DELETE_DATA_RESET',
        });
    };
}
